import "./style.scss";

const HeaderHome = () => {
  return <div>Header Home</div>;
};

export default HeaderHome;
